<template>
  <div class="dvanced-search">
    <div class="accurate-title">
      <div>
        <span class="word-color1 word-big" style="font-weight:bold">高级检索</span>
        <slot name="title-tip"></slot>
      </div>
      <span class="word-color3" style="cursor:pointer;font-size:24px;" @click="hideAccurate(false)"><i class="el-icon-close"></i></span>
    </div>
    <div>
      <courseFilter @filter="hideAccurate(true)" />
    </div>
  </div>
</template>

<script>
import courseFilter from './courseFilter';

export default {
  components: { courseFilter },
  data() {
    return {};
  },
  methods: {
    hideAccurate(status) {
      this.$emit("hideAccurate", status);
    }
  }
};
</script>

<style lang="less" scoped>
.dvanced-search {
  box-shadow: 0px 6px 11px 1px rgba(0, 0, 0, 0.06);

  .accurate-title {
    display: flex;
    justify-content: space-between;
    box-shadow: 0px 1px 0px 0px rgba(230, 230, 230, 1);
    height: 40px;
    padding: 0 15px 0 30px;
    line-height: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/cases/advancedSearch.vue